<template>
  <v-dialog
    id="user-list-generic-dialog"
    v-model="genericDialogDisplayed"
    max-width="640"
    persistent
  >
    <v-card>
      <v-card-title class="headline">{{ genericDialogTitle }}</v-card-title>
      <v-card-text>
        <span v-html="genericDialogBody"></span>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          id="user-list-generic-dialog--confirmation-button"
          :disabled="!genericDialogControlEnabled"
          :loading="genericDialogActionInProgress"
          color="primary"
          @click="confirmGenericDialogAction"
        >
          Yes
        </v-btn>
        <v-btn
          id="user-list-generic-dialog--cancellation-button"
          :disabled="!genericDialogControlEnabled"
          @click="cancelGenericDialogAction"
        >
          No
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import storeAction from '../lib/const/storeAction';
import systemEvent from '../lib/const/systemEvent';

export default {
  data() {
    return {
      functionCommonAdapter: false,

      genericDialogActionInProgress: false,
      genericDialogDisplayed: false,
      genericDialogUserEmail: '',
      genericDialogUserEnabled: false,
      genericDialogMode: '',
      genericDialogTitle: '',
      genericDialogBody: ''
    };
  },

  computed: {
    genericDialogControlEnabled() {
      return !this.genericDialogActionInProgress;
    }
  },

  methods: {
    async deleteUser() {
      const deleteUserData = {
        email: this.genericDialogUserEmail
      };
      const udUser = await this.$store
        .dispatch(storeAction.DELETE_USER, deleteUserData)
        .catch((err) => {
          this.genericDialogDisplayed = false;

          const errorDialogArgHash = {
            errorDialogTitle: 'User Deletion Failed',
            errorDialogBody: this.$app.userCommon.getApiHtmlErrorMessage(err),
            errorDialogDisplayed: true
          };
          this.$app.eventBus.$emit(systemEvent.USER_LIST_ERROR_DIALOG_CALLED, errorDialogArgHash);
        });

      if (udUser) {
        this.genericDialogDisplayed = false;

        this.$app.eventBus.$emit(systemEvent.USER_LIST_GENERIC_DIALOG_ACTION_DONE, true);
      }
    },

    async putUserEnabled() {
      const userEnabled = this.genericDialogUserEnabled;
      const putUserEnabledData = {
        email: this.genericDialogUserEmail,
        enabled: userEnabled
      };
      const udUser = await this.$store
        .dispatch(storeAction.PUT_USER_ENABLED, putUserEnabledData)
        .catch((err) => {
          this.genericDialogDisplayed = false;

          const enablementAction = userEnabled ? 'Enablement' : 'Disablement';
          const errorDialogArgHash = {
            errorDialogTitle: `User ${enablementAction} Failed`,
            errorDialogBody: this.$app.userCommon.getApiHtmlErrorMessage(err),
            errorDialogDisplayed: true
          };
          this.$app.eventBus.$emit(systemEvent.USER_LIST_ERROR_DIALOG_CALLED, errorDialogArgHash);
        });

      if (udUser) {
        this.genericDialogDisplayed = false;

        this.$app.eventBus.$emit(systemEvent.USER_LIST_GENERIC_DIALOG_ACTION_DONE, true);
      }
    },

    async confirmGenericDialogAction() {
      this.genericDialogActionInProgress = true;

      switch (this.genericDialogMode) {
        case 'user-deletion':
          this.functionCommonAdapter.push([this.deleteUser]);
          this.$app.authCommonAdapter.enforceUserAuthStrategy(this.$route, false);
          break;

        case 'user-enablement':
          this.functionCommonAdapter.push([this.putUserEnabled]);
          this.$app.authCommonAdapter.enforceUserAuthStrategy(this.$route, false);
          break;

        default:
          this.genericDialogDisplayed = false;
          break;
      }
    },

    cancelGenericDialogAction() {
      this.genericDialogMode = '';
      this.genericDialogDisplayed = false;
    },

    displayUserDeletionDialog(userEmail) {
      this.genericDialogUserEmail = userEmail;
      this.genericDialogMode = 'user-deletion';
      this.genericDialogActionInProgress = false;
      this.genericDialogDisplayed = true;

      this.genericDialogTitle = 'Confirm User Deletion';
      this.genericDialogBody = `<span>Do you really want to delete <b>${userEmail}</b>? This action cannot be undone.</span>`;
    },

    displayUserEnablementDialog(userEmail, userEnabled) {
      this.genericDialogUserEmail = userEmail;
      this.genericDialogUserEnabled = userEnabled;
      this.genericDialogMode = 'user-enablement';
      this.genericDialogActionInProgress = false;
      this.genericDialogDisplayed = true;

      let enablementAction = userEnabled ? 'Enablement' : 'Disablement';
      this.genericDialogTitle = `Confirm User ${enablementAction}`;
      enablementAction = userEnabled ? 'enable' : 'disable';
      this.genericDialogBody = `Do you really want to ${enablementAction} <b>${userEmail}</b>?`;
    },

    async handleAuthStrategyEnforcementResponse(sessionUser) {
      if (sessionUser) {
        this.functionCommonAdapter.execute();
      }
    }
  },

  async mounted() {
    const that = this;

    this.functionCommonAdapter = new this.$app.functionCommon.Adapter();

    this.$app.eventBus.$on(
      systemEvent.AUTH_STRATEGY_ENFORCEMENT_DONE,
      that.handleAuthStrategyEnforcementResponse
    );
  },

  beforeDestroy() {
    this.$app.eventBus.$off(systemEvent.AUTH_STRATEGY_ENFORCEMENT_DONE);
  }
};
</script>
